/*global google_config */
/* eslint-disable quotes */

import firebase from 'firebase/app';

// this is generated via webpack.DefinePlugin
// this plugin reads the config file google-config.json and injects the google config into the google_config variable
// the google-config.json file is generated after the firebase project is configured using the following command
// firebase --project $(gcloud config get project) apps:sdkconfig web --json > $(git rev-parse --show-toplevel)/web/google-config.json

firebase.initializeApp(google_config);

export default firebase;
